function capitalizeFirst (str) {
    return str ? str[0].toUpperCase() + str.slice(1).toLowerCase() : '';
}

export default capitalizeFirst;
